var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighestScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 4.57143C19.8857 4.57143 18.2514 9.344 16.6709 13.9589C15.1737 18.3337 13.6229 22.8571 10.2857 22.8571C9.50651 22.8113 8.75858 22.5346 8.1372 22.0622C7.51583 21.5898 7.04913 20.9431 6.79657 20.2046L4.62857 20.9326C4.68686 21.104 6.08114 25.1429 10.2857 25.1429C15.2571 25.1429 17.1566 19.5943 18.8343 14.6994C20.216 10.6663 21.52 6.85714 24 6.85714C24.7792 6.90297 25.5271 7.1797 26.1485 7.65209C26.7699 8.12448 27.2366 8.77115 27.4891 9.50971L29.656 8.78171C29.5989 8.61029 28.2046 4.57143 24 4.57143Z",
    fill: "#0923E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.28571 29.7143V17.1429H4.57143V14.8571H2.28571V0H0V29.7143C0 30.3205 0.240816 30.9019 0.66947 31.3305C1.09812 31.7592 1.67951 32 2.28571 32H32V29.7143H2.28571Z",
    fill: "#0923E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85714 14.8571H9.14286V17.1429H6.85714V14.8571ZM11.4286 14.8571H13.7143V17.1429H11.4286V14.8571ZM20.5714 14.8571H22.8571V17.1429H20.5714V14.8571ZM25.1429 14.8571H27.4286V17.1429H25.1429V14.8571ZM29.7143 14.8571H32V17.1429H29.7143V14.8571Z",
    fill: "#0923E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighestScore);
export default __webpack_public_path__ + "static/media/highest-score.daa7a76dcf5fb73ef5f3453e6d757ce0.svg";
export { ForwardRef as ReactComponent };